import React from "react";

import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { Typography } from "@picklebet/ui";
import { PageMessage } from "@picklebet/ui";

import { ReactComponent as DepositWarning } from "../assets/deposit-warning.svg";

type CheckLocationProps = {
  title: string;
  permission: string;
  children?: React.ReactNode;
};

const CheckLocation = ({ children, permission, title }: CheckLocationProps) => {
  if (
    [
      "CC_LOCATION_ERROR",
      "RESIDENTIAL_LOCATION_UNSUPPORTED",
      "PHYSICAL_LOCATION_UNSUPPORTED",
    ].includes(permission)
  ) {
    return (
      <PageMessage
        image={<DepositWarning />}
        title={title}
        subTitle={
          <Typography noSpacing>
            Find out more about our roll-out plans{" "}
            <SupportLink
              hideChevron
              options={{ labels: ["weblink-country-restrictions"] }}
            >
              here
            </SupportLink>
            .
          </Typography>
        }
      />
    );
  }

  return <>{children}</>;
};

export { CheckLocation };
